/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import _ from 'lodash';
import moment from 'moment';

import { withTranslation } from 'language/i18n';
import { getObjectByLanguage } from 'language/helpers';
import HelpIconWithTooltip from 'components/HelpIconWithTooltip';
import types from 'constants/types';
import useTimerHandler from 'pages/machinery/hooks/useTimerHandler';
import BidCounter from './BidCounter';
import AuctionDetail from './auction/AuctionDetail';
import ProductDetail from './ProductDetail';

const MachineInformation = ({
  t, setHowToAuctionWorkModalVisible, setMarketPlaceModalVisible, setCheckBidModalData, machine, offers, minimumIncrement, machineSoldPrice,
}) => {
  const { timeLeft, isTimeOver } = useTimerHandler({ machine, calculateStartingDateIfFutureEvent: true });

  return (
    <>
      <BidCounter machine={machine} timeLeft={timeLeft} />

      <div className="im-box im-box--white im-box--border-radius im-box--list-item im-box--padding-sm-15">
        <div className="row mb-4">
          <div className="col">
            <h1 className="fs-21 fw-900">{getObjectByLanguage(machine.title)}</h1>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <ul className="im-list im-list--type5">
              <li>
                <div className="im-list__label">{`${t('machineNo')}: `}</div>
                <div className="im-list__value">{machine.machineId}</div>
              </li>
              <li>
                <div className="im-list__label">{`${t('locationDif')}: `}</div>
                <div className="im-list__value">{`${machine.region}, ${getObjectByLanguage(machine.country.name)}`}</div>
              </li>
              <li>
                <div className="im-list__label">{`${t('saleType')}:`}</div>
                <div className="im-list__value">
                  {types[machine.event.type]}
                  <HelpIconWithTooltip position="bottom" className="ml-1">
                    <b>Pazarlık Usulü:</b>
                    {' '}
                    Açık Artırma’da en yüksek teklif makinanın rezerv fiyatını geçemezse, en yüksek teklifi veren alıcının satıcıyla pazarlık yapabilme imkanı doğar.
                  </HelpIconWithTooltip>
                </div>
              </li>
              <li>
                <div className="im-list__label">{`${t('sellBy')}:`}</div>
                {
                  !_.isEmpty(timeLeft)
                    && (
                      <div className="im-list__value fs-14">
                        <span className={`text-${moment(machine.event.endDate).format('d') > '1' ? 'green2' : 'red1'} mr-1`}>{`${timeLeft?.days ? `${timeLeft.days} gün` : ''} ${timeLeft.hours} saat`}</span>
                        {`(${moment(machine.event.endDate).format('DD MMMM, HH:mm')})`}
                      </div>
                    )
                }
              </li>
              <li>
                <div className="im-list__value" style={{ width: '100%', justifyContent: 'center' }}>
                  <span className="fs-13 text-gray3 fw-900 text-center" style={{ wordBreak: 'normal' }}>BU MAKİNA ERKEN KAPANIŞA TABİDİR.</span>
                  <HelpIconWithTooltip position="left" className="ml-1">
                    Erken Kapanış’a tabi olan makinalar Hemen Al seçeneğiyle satılabilirler. Makina Hemen Al seçeneğiyle satıldığında, açık artırmanın süresi dolmamasına rağmen açık artırma sonlanır.
                  </HelpIconWithTooltip>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="separator separator--horizontal separator--neg-margin-15 mt-4 mb-4" />
          </div>
        </div>

        <AuctionDetail
          setHowToAuctionWorkModalVisible={setHowToAuctionWorkModalVisible}
          machine={machine}
          setMarketPlaceModalVisible={setMarketPlaceModalVisible}
          offers={offers}
          setCheckBidModalData={setCheckBidModalData}
          minimumIncrement={minimumIncrement}
          machineSoldPrice={machineSoldPrice}
          timeLeft={timeLeft}
          isTimeOver={isTimeOver}
        />

        <div className="row">
          <div className="col">
            <div className="separator separator--horizontal separator--neg-margin-15 mb-4" />
          </div>
        </div>

        <ProductDetail machine={machine} />

        <div className="row">
          <div className="col">
            <div className="separator separator--horizontal separator--neg-margin-15 mb-4" />
          </div>
        </div>

        <div className="row align-items-center">
          <div className="col-3">
            <Image
              src="/image/stamp.svg"
              width="64"
              height="64"
            />
          </div>
          <div className="col">
            <p className="fs-13 m-0">
              <em className="fw-700">iyiMakina</em>
              {' '}
              tarafından incelendi. Satın alma işleminiz
              {' '}
              <em className="fw-700">{t('underTheGuaranteeOfIyiMakina')}</em>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

MachineInformation.propTypes = {
  t: PropTypes.func,
  setHowToAuctionWorkModalVisible: PropTypes.func,
  setMarketPlaceModalVisible: PropTypes.func,
  setCheckBidModalData: PropTypes.func,
  machine: PropTypes.object,
  offers: PropTypes.array,
  minimumIncrement: PropTypes.number,
  machineSoldPrice: PropTypes.number,
};

export default withTranslation('common')(MachineInformation);
